import React from 'react';
import { MODAL_IDS } from '@src/containers/Session/constants';
import { MessageCDynamicDeny } from '@src/components/Message/connectors/dynamic';
import PopupCDefault from '../connectors/default';

const PopupCSpaceDeny = () => {
	const [isLoading, setIsLoading] = React.useState(true);

	const handleMount = React.useCallback(() => {
		setIsLoading(false);
	}, []);

	return (
		<PopupCDefault
			isCentred
			isPlated
			modalId={MODAL_IDS.CLAIM_DENY}
			adaptive="message"
			isLoading={isLoading}
		>
			<MessageCDynamicDeny onMount={handleMount} />
		</PopupCDefault>
	);
};

export default PopupCSpaceDeny;
